import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './ExportListUIHelpers';

const ExportListUIContext = createContext()

export function useExportListUIContext() {
	return useContext(ExportListUIContext)
}

export function ExportListUIProvider({ exportListUIEvents, children }) {
	const [queryParams, setQueryParamsBase] = useState(initialFilter);
	const setQueryParams = useCallback((nextQueryParams) => {
		setQueryParamsBase((prevQueryParams) => {
			if (isFunction(nextQueryParams)) {
				nextQueryParams = nextQueryParams(prevQueryParams);
			}

			if (isEqual(prevQueryParams, nextQueryParams)) {
				return prevQueryParams;
			}

			return nextQueryParams;
		});
	}, []);


	const value = {
		queryParams,
		setQueryParamsBase,
		setQueryParams,
		newExportListClick: exportListUIEvents.newExportListClick,
		reloadData: exportListUIEvents.reloadData,
		openChooseExportListPage: exportListUIEvents.openChooseExportListPage
	};


	return (
		<ExportListUIContext.Provider value={value}>
			{children}
		</ExportListUIContext.Provider>
	);
}
